import React from 'react'

const Error = () => {
  return (
    <div className={'error'}>
        <h1>404 - Not Found</h1>

    </div>
  )
}

export default Error